import { createRouter, createWebHistory } from "vue-router";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HomeView from "../views/HomeView.vue";
import About from "@/views/About.vue";
import Contact from "@/views/Contact.vue";
import PrivacyView from "@/views/PrivacyView.vue";
import TermsView from "@/views/TermsView.vue";
import NotFoundView from "@/views/NotFoundView.vue";

const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/about", name: "about", component: About },
  {
    path: "/forbussines",
    name: "forbussines",
    component: () =>
      import(/* webpackChunkName: "forbussines" */ "../views/ForBussines.vue"),
  },
  {
    path: "/map",
    name: "map",
    component: () =>
      import(/* webpackChunkName: "map" */ "../views/MapView.vue"),
  },
  { path: "/contact", name: "Contact", component: Contact },
  {
    path: "/pricing",
    name: "pricing",
    component: () =>
      import(/* webpackChunkName: "pricing" */ "../views/PricingView.vue"),
  },
  { path: "/privacy", name: "privacy", component: PrivacyView },
  { path: "/terms", name: "terms", component: TermsView },
  { path: "/:pathMatch(.*)*", name: "not-found", component: NotFoundView },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  }
});
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}
router.beforeEach((to, from, next) => {
  document.body.style.overflow = 'auto'

  const html = document.documentElement
  const prevBehavior = html.style.scrollBehavior
  html.style.scrollBehavior = 'auto'
  console.log('[beforeEach] scrollY before scrollTo:', window.scrollY)
  window.scrollTo(0, 0)
  console.log('[beforeEach] scrollY after scrollTo:', window.scrollY)
  html.style.scrollBehavior = prevBehavior

  try {
    ScrollTrigger.getAll().forEach(t => { try { t.kill() } catch (_) {} })
    ScrollTrigger.clearScrollMemory()
  } catch (_) {}

  next()
})

router.afterEach(() => {
  document.body.classList.remove('page-loading')
  const html = document.documentElement
  const prevBehavior = html.style.scrollBehavior
  html.style.scrollBehavior = 'auto'
  requestAnimationFrame(() => {
    window.scrollTo(0, 0)
    html.style.scrollBehavior = prevBehavior
  })
});
export default router;
